export const TwitchWhite = ({ width = '20', height = '20' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.25 0L1 3.75V17.5H6V20H8.5L11 17.5H14.75L19.75 12.175V0H2.25ZM18.5 11.25L15 15H10.5675L7.875 16.9587V15H3.5V1.25H18.5V11.25ZM11 5H9.75V10H11V5ZM13.5 5H14.75V10H13.5V5Z"
        fill="white"
      />
    </svg>
  );
};
